import React, { Component } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar/index";
import Tabs from "@material-ui/core/Tabs/index";
import Tab from "@material-ui/core/Tab/index";
import { Util, runtime, createIcon, Request, Notification } from "../../common";
import { makeStyles } from '@material-ui/core/styles';
import { Html, theme as Styles, getThemeColor, getThemeColorValue, tryKeep, Scrollbar, Refreshable, UIComponent } from '../Base';
import ButtonBase from '@material-ui/core/ButtonBase';
import { auth } from "codeArt/auth";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { HelpLink } from "../Button";
import Tooltip from "../Tooltip";
import Badge from "../Badge";
import { Events } from "js/context";

let _loadedTabs = {};

function loadedTab(key, loaded) {
    if (Util.invalid(loaded)) return _loadedTabs[key];
    if (loaded) _loadedTabs[key] = true;
    else delete _loadedTabs[key];
}

class TabContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let { tabKey } = this.props;
        loadedTab(tabKey, true);
    }

    componentWillUnmount() {
        let { tabKey } = this.props;
        loadedTab(tabKey, false);
    }

    render() {
        let { children, hidden } = this.props;
        return <div className={`flex-column ${hidden ? 'd-none' : 'd-flex'} h-100`}>
            {children}
        </div>;
    }
}

let colors = {

}

export const navStyles = makeStyles(theme => ({
    // root: props => ({
    //   flexGrow: 1,
    //   display: 'flex',
    //   height: props.height,
    //   minHeight:props.minHeight
    // }),
    appBar: props => {
        if(runtime.mobile){
            return {
                position: "relative",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                background: "#fff",
                zIndex: "100!important",
                boxShadow: "none",
                borderBottom: `1px solid ${getThemeColorValue("line")}`,
                "& .MuiTabs-indicator": {
                   backgroundColor:Styles.color.primary
                },
                "& .MuiTabs-root":{
                    minHeight:"unset"
                }
            }
        }
        return {
            position: "relative",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background: "#fff",
            zIndex: "100!important",
            boxShadow: "none",
            borderBottom: `1px solid ${getThemeColorValue("line")}`,
            "& .MuiTabs-indicator": {
                display: "none"
            }
        }
    },
    tabs: props => {
        if(runtime.mobile){
            return {
                "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                    color: Styles.color.primary,
                    fontWeight:"bold"
                },
                "& .Mui-selected .MuiSvgIcon-root.c-tab-help": {  //活跃点（help颜色）
              
                },
                "& .MuiTab-wrapper": { //非活跃点颜色
                    flexDirection: "row",
                    alignItems: "center!important"
                },
                // "& .MuiTouchRipple-root": { //禁用水波纹点击效果，经过测试发现，禁用的不彻底
                //     position: "unset",
                // },
                "& .Mui-selected": {  //活跃点（选中的文字icon颜色）
                    // background: getThemeColorValue(props.activeColor) || Styles.color.primary
                }
            }
        }
        return {
            "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                color: Styles.color.white,
            },
            "& .Mui-selected .MuiSvgIcon-root.c-tab-help": {  //活跃点（help颜色）
                color: Styles.color.white,
            },
            "& .MuiTab-wrapper": { //非活跃点颜色
                flexDirection: "row",
                alignItems: "center!important"
            },
            // "& .MuiTouchRipple-root": { //禁用水波纹点击效果，经过测试发现，禁用的不彻底
            //     position: "unset",
            // },
            "& .Mui-selected": {  //活跃点（选中的文字icon颜色）
                background: getThemeColorValue(props.activeColor) || Styles.color.primary
            }
        }
    },
    tab: props => {
        if(runtime.mobile){
            return {
                opacity: 1,
                color: getThemeColorValue(props.textColor) || Styles.color.dark,
                fontSize: "0.98rem",
                "&:hover": {
                    // color: Styles.color.white,
                    // background: getThemeColorValue(props.activeColor) || Styles.color.primary
                },
                "&:hover .c-tab-help": {
                    color: Styles.color.white
                },
                "& .MuiSvgIcon-root": {
                    display:'none' //在手机模式下，不显示icon
                },
                "& .MuiSvgIcon-root.c-tab-help": {
                    marginRight: "0px!important"
                },
                "& .MuiSvgIcon-root.c-tab-help:hover": {
                    color: Styles.color.white
                },
                minHeight: "auto!important",
                minWidth: "auto!important",
                paddingLeft: "0.7rem",
                paddingRight: "0.7rem",
                paddingTop: "0.7rem",
                paddingBottom: "0.7rem",
                // marginLeft: "0.7rem",
                // marginRight: "0.7rem",
                marginTop: "0rem",
                marginBottom: "0rem"
            };
        }


        return {
            opacity: 1,
            color: getThemeColorValue(props.textColor) || Styles.color.dark,
            fontSize: "0.98rem",
            "&:hover": {
                color: Styles.color.white,
                background: getThemeColorValue(props.activeColor) || Styles.color.primary
            },
            "&:hover .c-tab-help": {
                color: Styles.color.white
            },
            "& .MuiSvgIcon-root": {
                fontSize: "1.22rem",
                marginBottom: "0!important",
                marginRight: "0.2rem!important"
            },
            "& .MuiSvgIcon-root.c-tab-help": {
                marginRight: "0px!important"
            },
            "& .MuiSvgIcon-root.c-tab-help:hover": {
                color: Styles.color.white
            },
            borderRadius: "5rem!important",
            minHeight: "auto!important",
            minWidth: "auto!important",
            paddingLeft: "1.5rem",
            paddingRight: "1.5rem",
            paddingTop: "0.3rem",
            paddingBottom: "0.3rem",
            marginLeft: "0.1rem",
            marginRight: "0.1rem",
            marginTop: "0.6rem",
            marginBottom: "0.6rem"
        };
    }
}));

const lineStyles = makeStyles(theme => ({
    appBar: props => {
        return {
            boxShadow: "none",
            backgroundColor: getThemeColor(props.background, "value") || "transparent",
            "& .MuiTabs-indicator": {
                background: getThemeColorValue(props.activeColor) || Styles.color.primary
            }
        }
    },
    tabs: props => {
        return {
            borderBottom: `1px solid ${props.activeColor ? getThemeColorValue(props.activeColor) : theme.palette.divider}`,
            "& .MuiTab-wrapper": { //非活跃点颜色
                color: getThemeColorValue(props.textColor) || getThemeColorValue("m-text-dark50"),
                flexDirection: "row",
                alignItems: "center!important",
                opacity: 1,
            },
            "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                fontWeight: props.activeWeight || "normal",
                color: getThemeColorValue(props.activeColor) || Styles.color.primary,
            },
            // "& .MuiTouchRipple-root": { //禁用水波纹点击效果，经过测试发现，禁用的不彻底
            //     position: "unset",
            // },
        }
    },
    tab: props => {
        return {
            minWidth: "auto!important",
            opacity: 1,
            fontSize: props.textSize || "1rem",
            "&:hover": {
                color: getThemeColorValue(props.activeColor) || Styles.color.primary,
                fontSize: props.indicatorTextSize
            },
            "& .MuiSvgIcon-root": {
                fontSize: "1.45rem",
                marginBottom: "0px!important",
                marginRight: "0.2rem!important"
            },
            minHeight: "auto",
            paddingTop: props.paddingTop || "0.8rem",
            paddingBottom: props.paddingBottom || "0.8rem",
            paddingLeft: "0",
            paddingRight: "0",
            marginRight: props.centered ? "0rem" : (props.itemSpace || "2rem"),
            marginTop: 1 //修正已选择下划线和容器下划线分离的bug
        };

    }
}));

const normalStyles = makeStyles(theme => ({
    appBar: props => {
        return {
            backgroundColor: getThemeColor(props.background, "value") || Styles.color.primary,
            "& .MuiTabs-indicator": {
                background: getThemeColorValue(props.activeColor) || Styles.color.secondary
            }
        }
    },
    tabs: props => {
        return {
            "& .Mui-selected .MuiTab-wrapper": {  //活跃点（选中的文字icon颜色）
                fontWeight: props.activeWeight || "normal",
                color: getThemeColor(props.activeColor, "value") || Styles.color.white,
            },
            "& .MuiTab-wrapper": { //非活跃点颜色
                color: getThemeColor(props.textColor, "value") || Styles.color.light,
            },
        }
    },
    tab: props => {
        return {
            fontSize: props.textSize || "auto",
            paddingTop: props.paddingTop || '',
            paddingBottom: props.paddingTop || '',
        }
    }
}));

const themeStyles = { "nav": navStyles, 'line': lineStyles, 'normal': normalStyles };
// const themeProps = ["background", "indicatorColor", "indicatorTextColor", "indicatorTextSize", "textColor", "textSize"];

// let themes = {
//     'nav': { indicatorColor: "primary", textColor: "primary" },
//     'line': { indicatorColor: "secondary", textColor: Styles.color.dark },
//     'normal': { indicatorColor: "secondary", textColor: Styles.color.dark }
// }



export default function HorizontalTabs(props) {

    let { theme, match, history, back, className, selectedIndex, onChange, items, full, headerClassName, containerScrollable, disableRipple, tools, keep, centered, bodyFull } = props;
    if (theme == "line") {
        disableRipple = true; //line风格下，不显示点击水波纹效果
    }

    items = items.filter((t) => {
        if (t.auth) return auth(t.auth);
        return true;
    });

    let hasIcon = items.filter((t) => t.icon).length > 0;

    const classes = themeStyles[theme]({ ...props, hasIcon });
    const [value, setValue] = React.useState(0);

    const handleChange = (event, value) => {
        setValue(value);
        if (onChange)
            onChange(value);
    };

    const getBody = (item, ctx) => {
        let { body } = item;
        var type = Util.type(body);
        if (type == "function") {
            return body({ item, ctx });
        }
        return body;
    }

    // const getThemeStyle = () => {
    //     let p = themes[theme];
    //     //检测是否有自定义样式
    //     themeProps.forEach((name) => {
    //         let value = props[name];
    //         if (value)
    //             p[name] = value;
    //     });
    //     return p;
    // }

    // let themeStyle = getThemeStyle();

    // if (runtime.mobile) {
    //     full = true;
    // }

    let current = selectedIndex === 0 ? selectedIndex : selectedIndex || value;

    const tabs = () => {
        return <Tabs
            className={classes.tabs}
            orientation={'horizontal'}
            value={current}
            centered={centered}
            onChange={handleChange}
            variant={full || centered ? 'fullWidth' : 'scrollable'}
            scrollButtons={"auto"}
        >
            {
                items.map((t, i) => {
                    let p = { ...t };
                    delete p.container; delete p.cache; delete p.body; delete p.tools; delete p.badge;
                    return <Tab component="div" className={classes.tab} key={i} disableRipple={disableRipple} {...p} label={<Label data={t} />} />;
                })
            }
            {tools ? <Panel>{tools}</Panel> : null}
        </Tabs>;
    }

/*     const getLabel = (t) => {
        if (!t.help) return t.label;
        return (
            <div className="d-flex flex-row justify-content-center align-items-center c-tabs-tab">
                {t.label}<a className="c-ml-2 c-lh-1" href={t.help} target="_blank" title={`${t.label} - 帮助`}>{createIcon(HelpOutlineIcon, "c-tab-help c-icon-s2d5 c-mr-0")}</a>
            </div>
        );
    } */

    let nav = theme === "nav";

    const tryScrollable = (content) => {
        if (!containerScrollable) return content;
        return (
            <div className="d-flex c-flex-1">
                <Scrollbar>
                    {content}
                </Scrollbar>
            </div>
        );
    }

    return (
        <div className={`d-flex flex-column w-100 ${containerScrollable || bodyFull ? 'h-100' : ''} ${className}`}>
            <AppBar position="static" color="default" className={`d-flex ${classes.appBar} ${headerClassName}`}>
                {tabs()}
            </AppBar>
            {/* {nav ? <div style={{ height: 58 }}></div> : null} */}
            {
                keep ? (
                    tryScrollable(items.map((t, i) => {
                        let tabKey = `${t.label}_${i}`;
                        if (loadedTab(tabKey) || current === i) {
                            return <TabContainer tabKey={tabKey} hidden={current != i} key={i}>{getBody(t, { match, history })}</TabContainer>;
                        }
                    }))
                ) : (
                    tryScrollable(items.map((t, i) => {
                        return (current === i && <TabContainer key={i}>{getBody(t, { match, history })}</TabContainer>)
                    }))
                )
            }
        </div>
    );
}

HorizontalTabs.defaultProps = {
    theme: "slim",
    full: false,
    className: '',
    headerClassName: '',
    disableRipple: false,
    keep: false
}


const Panel = ({ children }) => {

    return (
        <div className="d-flex c-flex-1 justify-content-end align-items-center">
            {children}
        </div>
    );
}

class Label extends UIComponent {
    constructor(props) {
        super(props);
        this.state = { badgeValue: 0 };
        let badge = props.data.badge;
        if (badge && badge.event) {
            this.on = (arg) => {
                if (arg.source == badge.event) {
                    this.loadBadge();
                }
            };
        }
    }

    componentWillMount() {
        super.componentWillMount();
        this.loadBadge();
    }

    loadBadge() {
        let { badge } = this.props.data;
        if (!badge) return;
        let p = badge;
        Request({
            ...p,
            before: () => {

            },
            complete: () => {

            },
            success: (r) => {
                if (this.isUnmounted()) return; //防止数据没加载完用户就取消浏览，导致的bug
                let value = p.success(r);
                this.setState({ badgeValue: value });
            },
            error: (msg) => {//Notification
                Notification.error(msg);
            }
        });
    }


    render() {
        let { data } = this.props;
        if (!data.help && !data.badge) return data.label;

        if (data.help) {
            return (
                <div className="d-flex flex-row justify-content-center align-items-center c-tabs-tab">
                    {data.label}
                    <a className="c-ml-2 c-lh-1" href={data.help} target="_blank" title={`${data.label} - 帮助`}>{createIcon(HelpOutlineIcon, "c-tab-help c-icon-s2d5 c-mr-0")}</a>
                </div>
            );
        }

        if (data.badge) {
            let { badgeValue } = this.state;
            return (
                <div className="d-flex flex-row justify-content-center align-items-center c-tabs-tab">
                    {data.label}
                    {badgeValue ? <Badge className="c-ml-2 c-lh-1" color={data.badgeColor || "danger"} size="sm">{badgeValue}</Badge> : null}
                </div>
            );
        }
    }
}
